import { MessageUserRoleEnum } from '@gumtree/web-bff/src/api/clients/conversations';
import { Conversation, ConversationsMap } from '@gumtree/shared/src/types/message-centre';

export const mergeConversations = ({
    existingConversations,
    conversations,
    appendIfNotPresent = false,
}: {
    existingConversations: ConversationsMap;
    conversations: Conversation[];
    appendIfNotPresent?: boolean;
}): { mergedConversations: ConversationsMap; hasNewConversations: boolean } => {
    let hasNewConversations = false;

    const mergedConversations = conversations.reduce((result, conversation) => {
        if (existingConversations[conversation.id] || appendIfNotPresent) {
            return {
                ...result,
                [conversation.id]: {
                    ...existingConversations[conversation.id],
                    ...conversation,
                },
            };
        }

        hasNewConversations = true;

        return result;
    }, existingConversations);

    return { mergedConversations, hasNewConversations };
};

export const getUserRole = ({
    conversations,
    activeConversationId,
    userId,
}: {
    conversations: ConversationsMap;
    activeConversationId: string | null;
    userId: number;
}): MessageUserRoleEnum => {
    const activeConversation = conversations[activeConversationId!] as Conversation;

    return userId === activeConversation.sellerId
        ? MessageUserRoleEnum.Seller
        : MessageUserRoleEnum.Buyer;
};
